<template>
    <TiptapEditor
        :placeholder="$t('chatbotv2.enterBotResponseHere')"
        :show-attributes="true"
        :show-emoji="true"
        v-model="text"
        :preview-mode="previewMode"
        :whatsapp-mode="whatsappMode"
        :allowed-attributes="allowedAttributes"
    />
</template>

<script>
import TiptapEditor from "../../common/TiptapEditor";

export default {
    name: "TextMessage",
    components: { TiptapEditor },
    props: {
        value: {
            type: String,
            required: true,
        },
        previewMode: {
            type: Boolean,
            default: false,
        },
        allowedAttributes: {
            type: Array,
            default: () => [],
        },
        whatsappMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            text: this.value,
        };
    },
    watch: {
        text(newValue) {
            this.$emit("input", newValue);
        },
    },
};
</script>

<style scoped></style>
